import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const STORY = [
  "Sviin wasn't born from a plan. It was born from trial and tribulation — seasons that tested everything and kept asking whether it was worth continuing.",
  "Faith carried it through. Perseverance kept it moving when nothing else would. And creativity turned every setback into something worth making.",
];

const CRAFT = [
  "Today, Sviin is focused on two things: the quality of the garment and the art placed on it. Every piece is built to last — chosen for its fabric, cut with care, finished with intention.",
  "And every piece carries a meaning deeper than what you see. What you wear is only the surface. The story lives underneath.",
];

const Block = ({ label, paragraphs }) => (
  <div className="grid gap-6 border-t py-14 md:grid-cols-12 md:py-20">
    <Reveal className="md:col-span-4">
      <p className="label text-[#111111]/60">{label}</p>
    </Reveal>
    <div className="space-y-6 md:col-span-8">
      {paragraphs.map((p, i) => (
        <Reveal key={i} delay={i * 0.08}>
          <p className="text-xl font-light leading-relaxed tracking-[-0.01em] text-[#111111]/85 md:text-2xl">{p}</p>
        </Reveal>
      ))}
    </div>
  </div>
);

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="font-['Geist',sans-serif]">
      <section className="mx-auto max-w-[1600px] px-4 pb-16 pt-14 md:px-8 md:pb-24 md:pt-24">
        <Reveal>
          <p className="label text-[#111111]/60">About</p>
          <h1 className="mt-6 max-w-4xl font-['Geist',sans-serif] text-4xl font-light leading-[1.05] tracking-[-0.04em] sm:text-5xl lg:text-7xl">
            The story behind Sviin.
          </h1>
        </Reveal>
      </section>
      <section className="mx-auto max-w-[1600px] px-4 md:px-8">
        <Block label="Where it began" paragraphs={STORY} />
        <Block label="What we make" paragraphs={CRAFT} />
        <Reveal className="border-t py-14 md:py-20">
          <Link to="/shop" data-testid="about-shop-link" className="label draw-link hover:text-[#E2541B]">Shop now</Link>
        </Reveal>
      </section>
    </div>
  );
}
